/**
 * Hardware variants preview + "Select Category" call-to-action.
 *
 * Renders on Hardware cards (nails / screws / patti / etc.) — shows up
 * to 6 size chips (with a "+N more" ellipsis), a rate preview for the
 * first variant across all its rate types (per box / kg / rft / dozen
 * / piece), and the Add button that opens the multi-select hardware
 * dialog.
 *
 * Extracted from ProductsPage.js. Pure JSX with two
 * props: `group` and `onSelectCategory` (fires the parent's
 * handleHardwareClick).
 */
import React from 'react';
import { Button } from '../../../components/ui/button';
import { Plus } from 'lucide-react';


export function HardwareVariantsBlock({ group, idx, onSelectCategory }) {
  const first = group.hardware_variants[0] || {};
  return (
    <div className="space-y-2 flex-1 flex flex-col">
      {/* Hardware type indicator */}
      <p className="text-xs text-[#8F9485] uppercase tracking-wide">
        {group.hardware_type}{' '}
        <span className="text-[#B45309]">({group.hardware_variants.length} sizes)</span>
      </p>

      {/* Show available sizes as read-only chips */}
      <div className="flex flex-wrap gap-1.5 mb-2">
        {group.hardware_variants.slice(0, 6).map((hv, hvIdx) => (
          <span
            key={hvIdx}
            className="px-2 py-1 text-xs bg-[#F5F6F0] rounded border border-[#E2E6D9] text-[#5C6150]"
          >
            {hv.size}
          </span>
        ))}
        {group.hardware_variants.length > 6 && (
          <span className="px-2 py-1 text-xs text-[#8F9485]">
            +{group.hardware_variants.length - 6} more
          </span>
        )}
      </div>

      {/* Rate preview for first variant — shows every rate type set */}
      <div className="text-xs text-[#5C6150]">
        {first.rate_box && <span className="mr-2">₹{first.rate_box}/box</span>}
        {first.rate_kg && <span className="mr-2">₹{first.rate_kg}/kg</span>}
        {first.rate_running_feet && <span className="mr-2">₹{first.rate_running_feet}/rft</span>}
        {first.rate_dozen && <span className="mr-2">₹{first.rate_dozen}/dzn</span>}
        {first.rate_piece && <span>₹{first.rate_piece}/pc</span>}
      </div>

      {/* Add Button — opens the hardware multi-select dialog */}
      <div className="mt-auto pt-2">
        <Button
          size="sm"
          className="w-full bg-[#B45309] hover:bg-[#92400E] text-white"
          onClick={() => onSelectCategory(group)}
          data-testid={`hardware-add-btn-${idx}`}
        >
          <Plus className="w-4 h-4 mr-1" /> Select Category
        </Button>
      </div>
    </div>
  );
}
